import * as actionTypes from '../../actions/action-types.js'
const initialState = {
    projsLastFetch: 0,
    taskLastFetch: 0,
    projsLoading: false,
    taskLoading: false,
    projects: null,
    task: null,
    project: null,
    projLoading: false,
    projLastFetch: 0,
}
const taskmanager = (state = initialState, action) => {
    const { data, type } = action || {}

    switch (type) {
        case actionTypes.STORE_INIT:
            return {
                ...initialState,
            }
        case actionTypes.FD_TSK_PROJS_REQUEST_SUCCESS:
            return {
                ...state,
                projsLoading: false,
                projsLastFetch: Date.now(),
                projects: data.projects,
            }
        case actionTypes.FD_TSK_PROJS_REQUEST:
            return {
                ...state,
                projsLoading: true,
            }
        case actionTypes.FD_TSK_PROJS_REQUEST_FAILURE:
            return {
                ...state,
                projsLoading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.FD_TSK_PROJS_CACHE:
            return state.projects || []
        case actionTypes.FD_TSK_PROJ_REQUEST_SUCCESS: {
            return {
                ...state,
                projLoading: false,
                projLastFetch: Date.now(),
                project: data.project,
            }
        }
        case actionTypes.FD_TSK_PROJ_REQUEST:
            return {
                ...state,
                projLoading: true,
            }
        case actionTypes.FD_TSK_PROJ_REQUEST_FAILURE:
            return {
                ...state,
                projLoading: false,
                error: action.error,
                lastError: Date.now(),
            }
        case actionTypes.FD_TSK_PROJ_CACHE:
            return state.project || null
        default: {
            return state
        }
    }
}

export default taskmanager
